import { isEqual } from 'lodash-es';
import { segmentChanged } from './segmentChanged';
import { getSegmentById } from './getSegmentById';
import { setSortingPreferences } from './setSortingPreferences';
import { getRouteListNameFromUrl } from '../../../utils/getRouteListNameFromUrl';

import type { Store, JsonFilters } from '../../../store/list/types';
import { addViewParamToUrl } from '.';

export const onLocationChange = (store: Store, enableFilterInteraction: () => void): void => {
  const routeName = getRouteListNameFromUrl();

  if (routeName !== 'playbacks' && routeName !== 'playbacks.list') {
    return;
  }

  const { sortBy, loaded, jsonFilters, currentSegment, segments, setCurrentSegment } =
    store.getState();

  if (loaded) {
    const searchParams = new URLSearchParams(window.location.search);

    const rawFiltersURLParams = searchParams.get('filters');
    const rawSegmentIdURLParams = searchParams.get('segment');
    if (rawFiltersURLParams) {
      // As url.searchParams is already decoded we don't need to call decodeURIComponent
      const newFilterQueryFormat = JSON.parse(rawFiltersURLParams);
      if (currentSegment || !isEqual(jsonFilters, newFilterQueryFormat)) {
        setCurrentSegment(null);
        segmentChanged(store, newFilterQueryFormat);
      }
    } else if (rawSegmentIdURLParams) {
      const currentSegmentId = parseInt(rawSegmentIdURLParams, 10) || -1;
      const newSegment = getSegmentById(currentSegmentId, segments);
      if (newSegment) {
        const newFilterQueryFormat = newSegment.filters;
        if (!currentSegment || !isEqual(jsonFilters, newFilterQueryFormat)) {
          setCurrentSegment(newSegment);
          segmentChanged(store, newFilterQueryFormat as JsonFilters);
          // Overview experiment
          enableFilterInteraction();
          addViewParamToUrl('list');
        }
      } else {
        setCurrentSegment(null);
      }
    }
  }
  // make sure sorting params are still up to date
  setSortingPreferences(sortBy as string);
};
